import React from "react";
import { Routes, Route } from "react-router-dom";
import { LogOut, Bell, Shield, BarChart3 } from "lucide-react";

// Import page components
import ProfessionalProfile from "../(User)Profile_Final";
import Documents_Page from "../(User)SelfService";
import Settings_Page from "../(All) settings";
import Leave_Page from "../(User)leave_Managment";
import Attendance_Page from "../(User)attendance_page";
import Mo3tiSalaryPage from "../(User)salary_Final";
import EscalationPage from "../(User)EscalationComplaints";

import Mo3tiLeavePage from "../(User)leave_Managment";
import Calendar from '../(All) Calendar/index.jsx';
import MessengerPage from '../(All) messenger';
import { mo3tiThemes } from "../../components/mo3tiThemes.js";
import SidebarWithTopbar from "../(All) Sidebar/SidebarWithTopbar";
import ViewTypeSwitcher from '../../components/ViewTypeSwitcher.js';
import GroupsManagement from "../(user) GroupsManagement";

import ThemeToggleButton from './components/ThemeToggleButton.jsx';
import { useUserProfileState } from './hooks/useUserProfileState.js';
import { getNavItems, buildEmployeeData, buildSalaryData } from './config/userProfileConfig.js';
import {
  getContainerStyles,
  getBackgroundOverlayStyles,
  getDecorativeContainerStyles,
  getCircleStyles,
  getGlobalStyles,
} from './styles/userProfileStyles.js';
import { hasAdminLevel } from './utils/adminLevelUtils.js';

const Mo3tiUserProfile = () => {
  // ============ HOOKS AND STATE ============
  const {
    user,
    profile,
    theme,
    isRTL,
    t,
    notifications,
    sidebarOpen,
    setSidebarOpen,
    isDarkMode,
    viewType,
    currentPage,
    handleViewTypeChange,
    handleLogout,
    handleSwitchManager,
    handlePageChange,
    toggleTheme,
  } = useUserProfileState();

  // ============ DATA CONFIGURATION ============
  const currentTheme = isDarkMode ? mo3tiThemes.dark : mo3tiThemes.light;

  const navItems = getNavItems(t);
  const employeeData = buildEmployeeData(profile, t);
  const salaryData = buildSalaryData(profile);

  // ============ STYLES ============
  const containerStyles = getContainerStyles(currentTheme, isRTL);
  const backgroundOverlayStyles = getBackgroundOverlayStyles(currentTheme);
  const decorativeContainerStyles = getDecorativeContainerStyles(currentTheme);
  const { circle1Styles, circle2Styles } = getCircleStyles(currentTheme, isRTL);
  const globalStyles = getGlobalStyles(isRTL, currentTheme, isDarkMode, sidebarOpen);

  // ============ CREATE PAGE PROPS ============
  const pageProps = {
    employeeData,
    salaryData,
    theme: currentTheme,
    isDarkMode,
    translations_admin: t,
    isRTL
  };

  // ============ MAIN RENDER ============
  return (
    <div style={containerStyles}>
      {/* Background Elements */}
      <div style={backgroundOverlayStyles} />
      <div style={decorativeContainerStyles}>
        <div style={circle1Styles} />
        <div style={circle2Styles} />
      </div>

      {/* Sidebar with Topbar */}
      <SidebarWithTopbar
        navItems={navItems}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        user={user}
        notifications={notifications}
        handleLogout={handleLogout}
        handleSwitchManager={handleSwitchManager}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        themeToggle={<ThemeToggleButton theme={theme} toggleTheme={toggleTheme} t={t} />}
        translations_admin={t}
        isRTL={isRTL}
        viewModeSwitcher={
          <ViewTypeSwitcher
            viewType={viewType}
            onSelect={(type) => handleViewTypeChange(type)}
            hasAdminLevel={() => hasAdminLevel()}
            role={localStorage.getItem('role')}
          />
        }
      >
        <div style={{
          padding: "0",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          marginTop: currentPage === "messages" ? 0 : 40,
        }}>
          <Routes>
            <Route path="/" element={<ProfessionalProfile {...pageProps} />} />
            <Route path="professionalProfile" element={<ProfessionalProfile {...pageProps} />} />
            <Route path="attendance" element={<Attendance_Page {...pageProps} />} />
            <Route path="salary" element={<Mo3tiSalaryPage {...pageProps} />} />
            <Route path="employee-services" element={<Documents_Page {...pageProps} />} />
            <Route path="calendar" element={<Calendar {...pageProps} />} />
            <Route path="messages" element={<MessengerPage {...pageProps} />} />
            <Route path="leave-management" element={<Leave_Page {...pageProps} />} />
            <Route path="escalation" element={<EscalationPage {...pageProps} />} />
            <Route path="groups" element={<GroupsManagement {...pageProps} />} />
            <Route path="settings" element={<Settings_Page {...pageProps} toggleTheme={toggleTheme} />} />
          </Routes>
        </div>
      </SidebarWithTopbar>

      {/* Global Styles */}
      <style>{globalStyles}</style>
    </div>
  );
};

export default Mo3tiUserProfile;
